export default __webpack_public_path__ + "static/media/agency_card_icon.f5c2c072.svg";